export default function () {
  const {serviceWorker} = navigator;
  serviceWorker && serviceWorker.getRegistration().then((registration) => {
    registration && registration.unregister().then((boolean) => console.log('sw unregistered'));
  });
}


// WEBPACK FOOTER //
// ./src/unregisterServiceWorker.js